import { createAction, props } from '@ngrx/store';
import {
    BadResponseWithError,
    TournamentsWithPagination,
} from '@shared/models/common.interface';
import { SmartTableResult } from '@shared/models/smart-table.interface';
import {
    CreateProfileRequest,
    UpdateProfileRequest,
} from '../../models/api/requests/user-management.request';
import {
    PlayerProfilesWithPagination,
    ProfileInfo,
    ProfileLogs,
} from '../../models/api/response/user-management.response';

export const FETCH_USERS = '[User Management]: Fetch users';
export const FETCH_USERS_SUCCESS = '[User Management]: Fetch users success';
export const FETCH_USERS_FAILURE = '[User Management]: Fetch users failure';

export const FETCH_PROFILE_INFO = '[User Management]: Fetch profile info';
export const FETCH_PROFILE_INFO_SUCCESS =
    '[User Management]: Fetch profile info success';
export const FETCH_PROFILE_INFO_FAILURE =
    '[User Management]: Fetch profile info failure';

export const FETCH_PROFILE_TOURNAMENTS =
    '[User Management]: Fetch profile tournaments';
export const FETCH_PROFILE_TOURNAMENTS_SUCCESS =
    '[User Management]: Fetch profile tournaments success';
export const FETCH_PROFILE_TOURNAMENTS_FAILURE =
    '[User Management]: Fetch profile tournaments failure';

export const PROFILE_TURN_OFF_2FA = '[User Management]: Profile turn off';
export const PROFILE_TURN_OFF_2FA_SUCCESS =
    '[User Management]: Profile turn off success';
export const PROFILE_TURN_OFF_2FA_FAILURE =
    '[User Management]: Profile turn off failure';

export const RESET_PROFILE_PASSWORD =
    '[User Management]: Reset profile password';
export const RESET_PROFILE_PASSWORD_SUCCESS =
    '[User Management]: Reset profile password success';
export const RESET_PROFILE_PASSWORD_FAILURE =
    '[User Management]: Reset profile password failure';

export const CREATE_PROFILE = '[User Management]: Create profile';
export const CREATE_PROFILE_SUCCESS =
    '[User Management]: Create profile success';
export const CREATE_PROFILE_FAILURE =
    '[User Management]: Create profile failure';

export const UPDATE_PROFILE = '[User Management]: Update profile';
export const UPDATE_PROFILE_SUCCESS =
    '[User Management]: Update profile success';
export const UPDATE_PROFILE_FAILURE =
    '[User Management]: Update profile failure';

export const DELETE_PROFILE = '[User Management]: Delete profile';
export const DELETE_PROFILE_SUCCESS =
    '[User Management]: Delete profile success';
export const DELETE_PROFILE_FAILURE =
    '[User Management]: Delete profile failure';

export const SEND_BROADCAST_NOTIFICATION =
    '[User Management] Send broadcast notification';
export const SEND_BROADCAST_NOTIFICATION_SUCCESS =
    '[User Management] Send broadcast notification success';
export const SEND_BROADCAST_NOTIFICATION_FAILURE =
    '[User Management] Send broadcast notification failure';
export const DEPOSIT_WALLET = '[Wallet] wallet deposit';
export const DEPOSIT_WALLET_SUCCESS = '[Wallet] wallet deposit success';
export const DEPOSIT_WALLET_FAILURE = '[Wallet] wallet deposit failure';

export const FETCH_USER_IP_LOGS = '[Admin Panel]: Fetch user ip logs';
export const FETCH_USER_IP_LOGS_SUCCESS =
    '[Admin Panel]: Fetch user ip logs success';
export const FETCH_USER_IP_LOGS_FAILURE =
    '[Admin Panel]: Fetch user ip logs failure';

export const UNBAN_USER = '[Admin Panel] Unban user';
export const UNBAN_USER_SUCCESS = '[Admin Panel] Unban user success';
export const UNBAN_USER_FAILURE = '[Admin Panel] Unban user failure';

export const fetchUserIpLogs = createAction(
    FETCH_USER_IP_LOGS,
    props<{
        payload: {
            profileId: string;
        };
    }>()
);

export const fetchUserIpLogsSuccess = createAction(
    FETCH_USER_IP_LOGS_SUCCESS,
    props<{
        payload: {
            logs: ProfileLogs[] | null;
        };
    }>()
);

export const fetchUserIpLogsFailure = createAction(
    FETCH_USER_IP_LOGS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const depositProfileWallet = createAction(
    DEPOSIT_WALLET,
    props<{
        payload: {
            playerId: string;
            amount: number;
            amountCurrency: string;
            paymentDescription: string;
        };
    }>()
);

export const depositProfileWalletSuccess = createAction(DEPOSIT_WALLET_SUCCESS);

export const depositProfileWalletFailure = createAction(
    DEPOSIT_WALLET_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const sendBroadcastNotification = createAction(
    SEND_BROADCAST_NOTIFICATION,
    props<{
        payload: any;
    }>()
);
export const sendBroadcastNotificationSuccess = createAction(
    SEND_BROADCAST_NOTIFICATION_SUCCESS
);

export const sendBroadcastNotificationFailure = createAction(
    SEND_BROADCAST_NOTIFICATION_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const fetchUsers = createAction(
    FETCH_USERS,
    props<{
        payload?: SmartTableResult;
    }>()
);

export const fetchUsersSuccess = createAction(
    FETCH_USERS_SUCCESS,
    props<{
        payload: PlayerProfilesWithPagination;
    }>()
);

export const fetchUsersFailure = createAction(
    FETCH_USERS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const fetchProfileInfo = createAction(
    FETCH_PROFILE_INFO,
    props<{
        payload: {
            profileId: string;
        };
    }>()
);

export const fetchProfileInfoSuccess = createAction(
    FETCH_PROFILE_INFO_SUCCESS,
    props<{
        payload: ProfileInfo;
    }>()
);

export const fetchProfileInfoFailure = createAction(
    FETCH_PROFILE_INFO_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const fetchProfileTournaments = createAction(
    FETCH_PROFILE_TOURNAMENTS,
    props<{
        payload: {
            profileId: string;
        };
    }>()
);

export const fetchProfileTournamentsSuccess = createAction(
    FETCH_PROFILE_TOURNAMENTS_SUCCESS,
    props<{
        payload: TournamentsWithPagination;
    }>()
);

export const fetchProfileTournamentsFailure = createAction(
    FETCH_PROFILE_TOURNAMENTS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const profileTurnOff2fa = createAction(
    PROFILE_TURN_OFF_2FA,
    props<{
        payload: {
            userId: string;
        };
    }>()
);

export const profileTurnOff2faSuccess = createAction(
    PROFILE_TURN_OFF_2FA_SUCCESS
);

export const profileTurnOff2faFailure = createAction(
    PROFILE_TURN_OFF_2FA_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const resetProfilePassword = createAction(
    RESET_PROFILE_PASSWORD,
    props<{
        payload: {
            userId: string;
        };
    }>()
);

export const resetProfilePasswordSuccess = createAction(
    RESET_PROFILE_PASSWORD_SUCCESS
);

export const resetProfilePasswordFailure = createAction(
    RESET_PROFILE_PASSWORD_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const createProfile = createAction(
    CREATE_PROFILE,
    props<{
        payload: CreateProfileRequest;
    }>()
);

export const createProfileSuccess = createAction(CREATE_PROFILE_SUCCESS);

export const createProfileFailure = createAction(
    CREATE_PROFILE_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const updateProfile = createAction(
    UPDATE_PROFILE,
    props<{
        payload: {
            profileId: string;
            request: UpdateProfileRequest;
        };
    }>()
);

export const updateProfileSuccess = createAction(UPDATE_PROFILE_SUCCESS);

export const updateProfileFailure = createAction(
    UPDATE_PROFILE_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const deleteProfile = createAction(
    DELETE_PROFILE,
    props<{
        payload: {
            profileId: string;
        };
    }>()
);

export const deleteProfileSuccess = createAction(DELETE_PROFILE_SUCCESS);

export const deleteProfileFailure = createAction(
    DELETE_PROFILE_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const unbanUser = createAction(
    UNBAN_USER,
    props<{
        profileId: string;
    }>()
);
export const unbanUserSuccess = createAction(UNBAN_USER_SUCCESS);

export const unbanUserFailure = createAction(
    UNBAN_USER_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
